import { Col, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { FadeInSlider } from '../../components';

const Shoutout = (props) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col marg={isMobile ? '85px 0 0' : '98px 0 0'} noFlex centerAll center>
      <FadeInSlider
        headerTitle={
          <Row wid="420px">
            <Text
              stencil
              size="72px"
              bold
              lineHt="54px"
              style={{
                letterSpacing: -3.5,
                textIndent: 50
              }}
            >
              {t('website.loveTheGame')}
            </Text>
          </Row>
        }
        headerText={[
          t('website.joinTheDedicated'),
          t('website.aSportsCommunity'),
          t('website.athletesMonetize'),
          t('website.fansConnectDirectly')
        ]}
        sliderElements={[
          {
            image: require('assets/images/tennis-phone-tilted.png'),
            title: t('website.shoutout!'),
            content: t('website.shoutoutSliderText1')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.connect!'),
            content: t('website.unlimitedAccess')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.stream!'),
            content: t('website.streamGamesFrom')
          }
        ]}
      />
    </Col>
  );
};

export default Shoutout;
